import React from 'react'
import { useNavigate } from 'react-router-dom';

export const FourZeroScreen = () => {

    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    }

    return (
        <div className="card-body p-sm-5 text-center">
            <h2 className="fw-bolder mb-4" style={{fontSize: 120}}>4<span className="text-danger">0</span>4</h2>
            <h4 className="fw-bold mb-2">Elemento no encontrado</h4>
            <p className="fs-12 fw-medium text-muted">Lo sentimos, la página que estás buscando no se puede encontrar. Por favor, verifica la URL o intenta con una página diferente en nuestro sitio.</p>
            <div className="d-flex align-items-center justify-content-center mt-4 pt-2">
                <button onClick={handleGoHome} className="btn btn-light-brand">Volver al inicio</button>
            </div>
        </div>   
    )
}
